module.exports = __webpack_public_path__ + "media/images/pocstock-about-us-hero-banner-1-0491c74933416454f13651990ae36207.jpg";